import React, { useState, useEffect } from 'react';
import { useAdmin } from '../../context/AdminContext';
import '../admin/AdminComponents.css';

const CategoryForm = ({ category, onClose }) => {
  const { categories, addCategory, updateCategory } = useAdmin();
  const [formData, setFormData] = useState({
    id: '',
    name: '',
    displayOrder: 0
  });

  useEffect(() => {
    const nextDisplayOrder = categories.reduce((highest, item, index) => {
      const order = Number(item.displayOrder ?? item.display_order ?? index);
      return Number.isFinite(order) ? Math.max(highest, order) : highest;
    }, -1) + 1;

    if (category) {
      setFormData({
        id: category.id || '',
        name: category.name || '',
        displayOrder: category.displayOrder ?? category.display_order ?? 0
      });
    } else {
      setFormData({
        id: '',
        name: '',
        displayOrder: nextDisplayOrder
      });
    }
  }, [category, categories]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.name) {
      alert('Please enter a category name');
      return;
    }

    if (!category && !formData.id) {
      alert('Please enter a category ID');
      return;
    }

    const displayOrder = Number(formData.displayOrder);
    if (!Number.isInteger(displayOrder) || displayOrder < 0) {
      alert('Display order must be a whole number of 0 or greater');
      return;
    }

    try {
      const categoryData = { ...formData, displayOrder };
      if (category) {
        await updateCategory(category.id, categoryData);
      } else {
        if (categories.find(c => c.id === formData.id)) {
          alert('Category ID already exists');
          return;
        }
        await addCategory(categoryData);
      }
      onClose();
    } catch (error) {
      alert(error.message || 'Failed to save category');
    }
  };

  return (
    <div className="admin-modal-overlay" onClick={onClose}>
      <div className="admin-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="admin-modal-header">
          <h3 className="admin-modal-title">
            {category ? 'Edit Category' : 'Add Category'}
          </h3>
          <button className="admin-modal-close" onClick={onClose}>×</button>
        </div>
        <div className="admin-modal-body">
          <form className="admin-form" onSubmit={handleSubmit}>
            <div className="admin-form-group">
              <label className="admin-form-label">ID *</label>
              <input
                type="text"
                name="id"
                className="admin-form-input"
                value={formData.id}
                onChange={handleChange}
                disabled={!!category}
                required
              />
              {category && (
                <small className="admin-form-hint">Category ID cannot be changed</small>
              )}
            </div>
            <div className="admin-form-group">
              <label className="admin-form-label">Name *</label>
              <input
                type="text"
                name="name"
                className="admin-form-input"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="admin-form-group">
              <label className="admin-form-label">Display Order *</label>
              <input
                type="number"
                name="displayOrder"
                className="admin-form-input"
                value={formData.displayOrder}
                onChange={handleChange}
                min="0"
                step="1"
                required
              />
              <small className="admin-form-hint">Lower numbers appear first on the Shop page</small>
            </div>
            <div className="admin-form-actions">
              <button type="button" className="admin-button" onClick={onClose}>
                Cancel
              </button>
              <button type="submit" className="admin-button primary">
                {category ? 'Update' : 'Create'}
              </button>

            </div>

          </form>

        </div>

      </div>

    </div>

  );
};

export default CategoryForm;
